var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"UCsPNcgP556dpIVuzsjbk"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

// Use NEXT_PUBLIC_ prefixed environment variables for client-side access
// These are defined in next.config.js env section
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN || "";
const SENTRY_ENV = process.env.NEXT_PUBLIC_SENTRY_ENV || "development";
const STAGE = process.env.NEXT_PUBLIC_STAGE || "development";
const shouldEnableSentry = STAGE === "production" || STAGE === "preprod";

Sentry.init({
  environment: SENTRY_ENV,
  enabled: shouldEnableSentry,
  dsn: shouldEnableSentry ? SENTRY_DSN : undefined,
  ignoreErrors: [
    "Non-Error promise rejection captured", // Added in reference with https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/11
    "ResizeObserver loop limit exceeded", // https://forum.sentry.io/t/resizeobserver-loop-limit-exceeded/8402
    "ResizeObserver loop completed with undelivered notifications"
  ],
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  replaysOnErrorSampleRate: 0.1,

  // This sets the sample rate to be 1% in production, 10% in development to reduce quota usage
  replaysSessionSampleRate: 0.01
});
